<template>
  <li class="wf-flex wf-justify-between wf-py-1">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Container Size</span>
    <div class="wf-w-1/2">
      <VueSlider
        ref="size-slider"
        v-model="size"
        :interval="1"
        adsorb
        tooltip="none"
        :duration="0"
        :data="sizeClasses"
      />
    </div>
  </li>
</template>

<script>
  import _ from 'lodash'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import { ContentSizeClasses } from '../classes/ContentSizeClasses'
  export default MenuStyleProperty.extend({
    computed: {
      sizeClasses() {
        return Object.keys(ContentSizeClasses)
      },
      size: {
          get() {
            let currentSize = this.elementClasses(this.classes)[this.device].find(elementClass => this.sizeClasses.includes(elementClass.value))
            if (! currentSize) {
              currentSize = {property: 'ContentSize', value: 'SIZE_LG', touched: false}
              this.addToArray(this.module, [currentSize], this.classes, this.device, {}, true, this.parentModule)
            }
            return currentSize.value
          },
          set: _.debounce(function (value) {
            let currentSize = this.elementClasses(this.classes)[this.device].find(elementClass => this.sizeClasses.includes(elementClass.value))
            value = {property: 'ContentSize', value: value, touched: currentSize.touched}
            this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
          }, 250)
      },
    }
  })
</script>
